import { render, staticRenderFns } from "./noticeIcon.vue?vue&type=template&id=77b295a3&scoped=true&"
import script from "./noticeIcon.vue?vue&type=script&lang=ts&"
export * from "./noticeIcon.vue?vue&type=script&lang=ts&"
import style0 from "./noticeIcon.vue?vue&type=style&index=0&id=77b295a3&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77b295a3",
  null
  
)

export default component.exports